<template>
  <form @submit.prevent="save_event" class="mt-8">
    <m-row>
      <m-col lg="6">
        
        <memlist-text-input
          id="num_seats"
          name="num_seats"
          layout="vertical"
          :title="$t('EVENT.NUM_SEATS')"
          validation_type="TEXT"
          v-model="local_item.num_seats"
          @input="on_change"
        />
      </m-col>
      <m-col lg="6">
        <memlist-text-input
          id="num_signups"
          name="num_signups"
          layout="vertical"
          :title="$t('EVENT.NUM_SIGNUPS')"
          validation_type="TEXT"
          v-model="local_item.num_signups"
          @input="on_change"
          disabled
        />
      </m-col>
    </m-row>
    <m-row>
      <m-col lg="6">
        <memlist-text-input
          id="max_tickets_per"
          name="max_tickets_per"
          layout="vertical"
          :title="$t('EVENT.MAX_TICKETS_PER_PERSON')"
          validation_type="TEXT"
          v-model="local_item.max_tickets_per"
          @input="on_change"
        />

      </m-col>
    </m-row>

  </form>
</template>

<script>
export default {
  props: ['item'],
  watch: {
    
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_item = JSON.parse(JSON.stringify(this.item));
      },
      immediate: true
    },

  },
  methods: {
    save_event() {},
    on_change() {
      setTimeout(()=>{
        console.log('change', this.local_item)
        this.$emit('change', this.local_item);
      },100);
    }
  },
  data() {
    return {
      local_item: {}
    }
  },
}
</script>
